import { EramMessageElement } from "@poscon/shared-types/eram";
import type { RootThunkAction } from "../store";

import { processEramMessage as processMessage } from "@poscon/shared-frontend";

export const processEramMessage = (
  message: EramMessageElement[],
  sentFromGraphicalMenu = true,
): RootThunkAction<Promise<boolean>> => {
  return async (dispatch) => {
    return await dispatch(processMessage(message, "ERAM", sentFromGraphicalMenu));
  }
}


